import React from 'react';
import PropTypes from 'prop-types';

import useVerifyPlaidLink from '../../../../hooks/useVerifyPlaidLink';
import FlatButton from '../../../FlatButton';
import InlineAlert from '../../../InlineAlert';
import { Paragraph } from '../../../Typography';

import styles from './VerifyBankAlert.module.scss';

const VerifyBankAlert = ({ paymentMethodId }) => {
  const { open, loading } = useVerifyPlaidLink(paymentMethodId);

  return (
    <InlineAlert type="warning" contentClassName={styles.content}>
      <div className={styles.textHolder}>
        <Paragraph weight="bold" className="mb-8">
          Bank account not verified
        </Paragraph>
        <Paragraph className="mt-0 mb-0">
          You'll get a $0.01 deposit with a 3-letter code in the transaction's
          description. You must enter this code to verify your account.{' '}
        </Paragraph>
      </div>
      <FlatButton
        disabled={loading}
        loading={loading}
        className={styles.button}
        onClick={open}
      >
        enter code
      </FlatButton>
    </InlineAlert>
  );
};

VerifyBankAlert.propTypes = {
  paymentMethodId: PropTypes.string,
};

export default VerifyBankAlert;
